<template>
  <div>
    <img id='upbutton' src="static/images/zd.jpg" @click="backTop">
    <!-- <img id='scan' src="static/images/jianjie.jpg" /> -->
    <router-link  :to="{ path: '/Admissionnotice', query: { act: 'first' } }" id='scan'>会员入口</router-link>
    <!-- <a id='scan' href="#/Admissionnotice">会员入口</a> -->
  </div>
</template>

<script>
export default {
  name: "Suspend",
  mounted(){           window.addEventListener('scroll',this.scrollToTop,true)
  },
  destroyed(){          window.removeEventListener('scroll',this.scrollToTop)
  },
  methods: {
    backTop(){
      const that = this;
      let timer= setInterval(()=>{
        let upSpeed = Math.floor(-that.scrollTop/5);
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + upSpeed;
        if(that.scrollTop === 0){
          clearInterval(timer);
        }
      },16)
    },
    scrollToTop(){
      //alert('进入');，添加次语句可用于测试此时的浏览器窗口距离顶部是否》60
      //计算距离顶部的高度（高度大于60，显示返回按钮，否则隐藏）
      const that=this;
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
      if(that.scrollTop > 60){
        that.btnFlag=true;
      }else{
        that.btnFlag=false;
      }
    },
  }
}
</script>

<style scoped>
#scan {
  position: fixed;
  right :5%;
  top:55%;
  width:50px;
  /* width: 117px; */
  background-color: rgba(37,164,180);
  text-align: center;
  font-weight: bold;
  font-size: 19px;
  color: #fff;
  text-decoration: none;

}
</style>



// WEBPACK FOOTER //
// src/components/common/Suspend.vue